import React from "react";

/**
 * TitleDisclaimer — Agent default disclaimer rendered in the title container.
 * Shows "Highlighted in Blue" text when agent has filtered listings.
 */
function TitleDisclaimer({ miniTableSubTitle = "" }) {
  return (
    <div className="ye2-shortened-table-disclaimer">
      <div
        className="ye2-shortened-table-disclaimer-text"
        dangerouslySetInnerHTML={{ __html: miniTableSubTitle }}
      />
    </div>
  );
}

export default TitleDisclaimer;
